import { render, staticRenderFns } from "./editsupplier.vue?vue&type=template&id=1acf1f0c&"
import script from "./editsupplier.vue?vue&type=script&lang=ts&"
export * from "./editsupplier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editsupplier.vue"
export default component.exports